import React from 'react';
import { format } from 'date-fns';

/**
 * Component to display a list of court decisions
 * @param {Object} props - Component props
 * @param {Array} props.decisions - List of decisions to display
 * @param {string} props.title - Title for the list section
 * @param {boolean} props.showRelevance - Whether to show relevance score
 * @param {boolean} props.showAnalysis - Whether to show defense analysis
 * @param {boolean} props.showSummary - Whether to show case summary
 */
const DecisionList = ({ 
  decisions, 
  title, 
  showRelevance = false, 
  showAnalysis = false,
  showSummary = false 
}) => {
  if (!decisions || decisions.length === 0) {
    if (title) {
      return (
        <div className="decision-list empty">
          <h3>{title}</h3>
          <p>No decisions found for this period.</p>
        </div>
      );
    }
    return null;
  }

  return (
    <div className="decision-list">
      {title && <h3>{title}</h3>}
      <ul className="decision-items">
        {decisions.map((decision) => (
          <li key={decision.id} className="decision-item">
            <div className="decision-header">
              <span className="title-container">
                <a
                  href={decision.pdf_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="decision-title"
                >
                  {decision.case_name}
                </a>
              </span>
              <div className="decision-meta">
                <span className="circuit">{decision.circuit_name}</span>
                <span className="date">
                  {format(new Date(decision.filing_date), 'MMM d, yyyy')}
                </span>
                {showRelevance && (
                  <span className={`relevance relevance-${decision.relevance_score}`}>
                    Relevance: {decision.relevance_score}/4
                  </span>
                )}
              </div>
            </div>
            
            {showSummary && decision.summary && (
              <div className="decision-summary">
                <h4>Summary:</h4>
                <div className="summary-content">{decision.summary}</div>
              </div>
            )}
            
            {showAnalysis && decision.defense_analysis && (
              <div className="defense-analysis">
                <div 
                  className="analysis-content" 
                  dangerouslySetInnerHTML={{ __html: decision.defense_analysis }}
                ></div>
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DecisionList;